function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var NOL_ICON_ID = '__nol__icon';
function isNolIcon(arg) {
  return !!arg && _typeof(arg) === 'object' && arg[NOL_ICON_ID] === true;
}
function createNolIcon(source) {
  var clone = source;
  clone[NOL_ICON_ID] = true;
  return clone;
}

export { createNolIcon as c, isNolIcon as i };
